<template>
  <div class="fc-content text-break">
    <va-popover
      v-if="eventData.type"
      :message="getEventTypeLabel"
      placement="top"
      :popover-styles="popoverStyles"
      :background-color="eventData.type.color ? eventData.type.color : '#29c4a9'">

      <EventDisplay :event="eventData"/>

    </va-popover>

    <EventDisplay v-else :event="eventData"/>
  </div>

</template>

<script>
import EventDisplay from "@/components/leads-agenda/EventDisplay";
const DEFAULT_COLOR = '#29c4a9'

export default {
  components: {EventDisplay},
  props: {
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
  },
  computed: {
    eventData: function () {
      return {
        ...this.event.extendedProps,
        start: this.event.start,
        end: this.event.end
      }
    },
    getEventTypeLabel: function () {
      if (!this.eventData.type) return null

      let label = this.$t(`leads.agenda.event_types.${this.eventData.type.name}`)

      if (this.eventData.type.slug && label !== this.eventData.type.slug) {
        label += ` (${this.eventData.type.slug})`
      }
      return label
    },
    popoverBackgroundColor: function () {
      return this.eventData.type && this.eventData.type.color ? this.eventData.type.color : DEFAULT_COLOR
    },
    popoverStyles: function () {
      return {
        color: 'white',
        'font-size': '0.8rem',
        'background-color': this.popoverBackgroundColor
      }
    }
  }
}
</script>

<style scoped>

</style>
